import { useMemo } from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "@material-ui/core";
import ExploreIcon from "@material-ui/icons/Explore";
import { RutaVueloStyle } from "./styles";

const RutaVuelo = ({ vuelo, esRedondo }) => {
  const classes = RutaVueloStyle();
  const { Origen, Destino } = vuelo;
  const { escalasVuelo, escalasVueloRegreso } = useSelector(store => store.vueloProveedor);

  const escalasActualizadas = useMemo(() => {
    return esRedondo ? escalasVueloRegreso : escalasVuelo;
  }, [esRedondo, escalasVuelo, escalasVueloRegreso]);
  
  const escalas = useMemo(() => escalasActualizadas ?? [], [escalasActualizadas]);
  const numEscalas = escalas.length;

  // Lógica para definir el ancho de la línea según la cantidad de escalas:
  const lineWidth = useMemo(() => {
    return numEscalas > 0 ? 4 + numEscalas * 2 : 4; // En rem
  }, [numEscalas]);

  const escalaDots = useMemo(() => {
    if (numEscalas === 0) return null;

    return escalas.map((escala, index) => (
      <Tooltip key={index} title={escala.CodigoIATA.Descripcion} arrow>
        <div
          className={classes.dot}
          style={{
            left: `${((index + 1) / (numEscalas + 1)) * 100}%`,
          }}
        />
      </Tooltip>
    ));
  }, [escalas, numEscalas, classes.dot]);

  return (
    <div className={classes.container}>
      <ExploreIcon color="primary" className={classes.exploreIcon} />
      <Tooltip title={Origen?.Descripcion} arrow>
        <span>{Origen?.CodigoIATA}</span>
      </Tooltip>
      <div className={classes.lineContainer} style={{ width: `${lineWidth}rem` }}>
        {escalaDots}
      </div>
      <Tooltip title={Destino?.Descripcion} arrow>
        <span>{Destino?.CodigoIATA}</span>
      </Tooltip>
    </div>
  );
};

export default RutaVuelo;
